(function($) {

  $.fn.shorten = function(settings) {

   var config = $.extend( {
     showChars : 100,
     ellipsesText : "...",
     moreText : "more",
     lessText : "less",
     removeTags : true
    }, settings);

    return this.each(function() {
        var $this = $(this),
            content = $.trim($this.html());


        $this.attr('data-more', config.moreText);
        $this.attr('data-less', config.lessText);
        if (content.length > config.showChars) {
            var c = content.substr(0, config.showChars);
            if (c.indexOf('<') >= 0) // If there's HTML don't want to cut it
            {
            var inTag = false; // I'm in a tag?
            var bag = ''; // Put the characters to be shown here
            var countChars = 0; // Current bag size
            var openTags = []; // Stack for opened tags, so I can close them later

            for (i=0; i<content.length; i++)
            {
                if (content[i] == '<' && !inTag)
                {
                inTag = true;

                // This could be "tag" or "/tag"
                tagName = content.substring(i+1, content.indexOf('>', i));

                // If its a closing tag
                if (tagName[0] == '/')
                {
                    if (tagName != '/'+openTags[0]) {
                    //
                    }
                    else
                    openTags.shift(); // Pops the last tag from the open tag stack (the tag is closed in the retult HTML!)
                }
                else
                {
                    // There are some nasty tags that don't have a close tag like <br/>
                    if (tagName.toLowerCase() != 'br')
                    openTags.unshift( tagName );// Agrega al inicio el nombre de la tag que abre
                }
                }
                if (inTag && content[i] == '>')
                {
                inTag = false;
                }

                if (inTag) bag += content[i]; // Add tag name chars to the result
                else
                {
                if (countChars < config.showChars)
                {
                    bag += content[i];
                    countChars ++;
                }
                else // Ya tengo los caracteres necesarios
                {
                    if (openTags.length > 0) // Tengo tags sin cerrar
                    {
                    for (j=0; j<openTags.length; j++)
                    {
                        bag += '</'+ openTags[j] +'>'; // Cierro todas las tags que quedaron abiertas
                    }
                    break;
                    }
                }
                }
            }
            c = bag;
            }

            if (config.removeTags) {
                // Removing the <p> from the short text
                var c = c.replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '');

                c = c.replace(/<br\s*\/?>/gi, ' ');
            }

            var html = '<r-span class="shortcontent">' + c + config.ellipsesText +
                    '</r-span><r-span class="allcontent">' + content +
                    '</r-span>&nbsp;<r-span><a href="javascript://nop/" class="morelink">' + config.moreText + '</a></r-span>';

            $this.html(html);
            $(".allcontent").hide(); // Esconde el contenido completo para todos los textos
        }

        $this.addClass('is-loaded');
    });
  };
})(jQuery);

$(function() {
    $('body').on('click', '.morelink', function() {
        var $this = $(this);

        if ($this.hasClass('less')) {
            $this.removeClass('less');
            $this.html($this.parent().parent().attr('data-more'));

            $this.parent().prev().prev().show();
            $this.parent().prev().hide();
        } else {
            $this.addClass('less');
            $this.html($this.parent().parent().attr('data-less'));

            $this.parent().prev().prev().hide();
            $this.parent().prev().show();
        }

        return false;
    });
});
